import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {toastr} from "react-redux-toastr";
import { API_MESSAGES } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { PaginationProps } from "../../../common/types/PaginationProps";
interface IGetMessagesResponse {
    totalItems: 0,
    pageNum: 0,
    pageSize: 0,
    message: "string",
    isOK: true,
    sort: 0,
    sortField: string,
    search: string,
    items: ILoggingItem[],
    totalPages: number
}

interface ILoggingMessagesState {
    pagination: PaginationProps,
    messages: ILoggingItem[]
}

export interface ILoggingItem {
    id: number,
    type: string,
    message: string,
    source: string,
    time: string
}

const initialState: ILoggingMessagesState = {
    pagination: {
        activePage: 1,
        pageSize: 10,
        totalPages: 1
    },
    messages: []

}

export const getMessages = createAsyncThunk<IGetMessagesResponse, string, { rejectValue: string }>(
    'logging/get-messages',
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_MESSAGES}/?${query}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const deleteMessage = createAsyncThunk<{ id: number | string }, string | number, { rejectValue: string }>(
    'logging/delete-message',
    async (id, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.delete(`${API_MESSAGES}/${id}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const LoggingMessagesSlice = createSlice({
    name: 'loggingMessages',
    reducers: {
        setPageNum: (state, action) => {
            state.pagination.activePage = action.payload
        },
        changePageSize:(state,action) => {
            state.pagination.pageSize = action.payload
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getMessages.pending, (state: ILoggingMessagesState) => {

            })
            .addCase(getMessages.fulfilled, (state: ILoggingMessagesState, action) => {
                state.messages = action.payload.items
                state.pagination.totalPages = action.payload.totalPages
            })

            .addCase(deleteMessage.fulfilled, (state: ILoggingMessagesState, action) => {
                state.messages = state.messages.filter(exc => exc.id !== action.meta.arg)
            })

    }
})
export const {setPageNum,changePageSize} = LoggingMessagesSlice.actions
export default LoggingMessagesSlice.reducer;



